import { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { setText, workerLookup } from './../../store/WorkerLookup/actionCreator'
import { CircularProgress } from '@material-ui/core/'
import { withStyles } from '@material-ui/core/styles'
import WorkerLookupItems from '../WorkerLookupLayout/WorkerLookupItems'
import { string, func, arrayOf, shape, bool, object } from 'prop-types'

const styles = (theme) => ({
  spinner: {
    color: theme.palette.primary.main,
  },
  iconStyle: {
    width: '24px',
    height: '24px',
  },
})

export class WorkerLookupTable extends Component {
  constructor(props) {
    super(props)
    this.state = {
      blossomID: this.props.blossomIDFromParent,
    }
    this.setWorkerData(this.props.blossomIDFromParent)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { blossomIDFromParent } = this.props
    const { blossomIDFromParent: nextblossomIDFromParent } = nextProps
    // method to see if the reports need to be refreshed
    if (blossomIDFromParent !== nextblossomIDFromParent) {
      this.setState({ blossomID: nextProps.blossomIDFromParent })
      this.setWorkerData(nextProps.blossomIDFromParent)
    }
  }

  setWorkerData(value) {
    // Added location_typeList for revised method to get locations and distro lists
    let location_typeList = []
    this.props.setText(value)
    if (value === 'bcp') {
      location_typeList = ['OFFICE', 'TEST']
    } else if (value === 'CI00598283') {
      location_typeList = ['OFFICE', 'RGD', 'DC', 'STR', 'TEST']
    } else if (value === 'c3alert') {
      location_typeList = ['OFFICE', 'TEST']
    } else if (value === 'ceebackup') {
      location_typeList = ['RGD']
    } else if (value === 'c3aalert') {
      location_typeList = ['OFFICE', 'TEST']
    } else if (value === 'developer') {
      location_typeList = ['OFFICE', 'TEST']
    } else if (value === 'shipt') {
      location_typeList = ['SHIPT']
    }
    this.props.workerLookup(value, location_typeList)
  }

  selectionFlatDataCallback = (selections) => {
    this.checkWorkerSelected(selections)
  }

  selectionCountryCodeDataCallback = (selections) => {
    this.checkCountryCodeSelected(selections)
  }

  selectionDataCallback = (selections) => {
    this.props.callbackFromParentSelections(selections)
  }

  setHeaderData() {
    const { blossomID } = this.state
    let headerTitle = ''
    if (blossomID === 'c3alert' || blossomID === 'c3aalert') {
      headerTitle = 'Location # / Distribution List'
    } else if (blossomID === 'ceebackup') {
      headerTitle = 'RGD Location #'
    } else if (blossomID === 'CI00598283') {
      headerTitle = 'Store'
    } else if (blossomID === 'fmocdc') {
      headerTitle = 'Alert Distribution List Name'
    } else if (blossomID === 'developer') {
      headerTitle = 'Developer Distribution List Name'
    } else if (blossomID === 'shipt') {
      headerTitle = 'Shipt Distribution List Name'
    }
    return headerTitle
  }

  checkWorkerSelected(newSelected) {
    this.props.callbackFromParent(newSelected)
    this.props.callbackFromParentTotals(this.getTotals(newSelected))
  }

  checkCountryCodeSelected(countryCodeSelected) {
    this.props.callbackFromParentCountryCode(countryCodeSelected)
  }

  // simply interate through all of the results, and add up the totals
  getTotals(newSelected) {
    let i = 0
    this.props.responseData.forEach((x) => {
      if (newSelected[x.location_id]) {
        if (x.team_members) {
          i += x.team_members
        }
      }
    })
    return i
  }

  static defaultProps = {}
  render() {
    const { classes, fetchingState, responseData } = this.props
    const { blossomID } = this.state

    // Create variables from values of matching keys
    let toRender = <br />

    if (fetchingState === false && responseData == null) {
      toRender = <br />
    } else if (fetchingState === true) {
      toRender = (
        <span>
          <CircularProgress className={classes.spinner} thickness={7} />
          <h3>loading...</h3>
        </span>
      )
    } else if (responseData != null) {
      toRender = (
        <WorkerLookupItems
          headerName={this.setHeaderData()}
          blossomIDFromParent={blossomID}
          dataFromParent={responseData}
          fetchingState={fetchingState}
          callbackFromParentSelections={this.selectionDataCallback}
          callbackFromParentFlatSelections={this.selectionFlatDataCallback}
          callbackFromParentCountryCodeSelections={
            this.selectionCountryCodeDataCallback
          }
        />
      )
    }

    return <span>{toRender}</span>
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setText,
      workerLookup,
    },
    dispatch,
  )

const mapStateToProps = (state) => ({
  responseData: state.workerLookup.data,
  fetchingState: state.workerLookup.fetching,
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(WorkerLookupTable))

WorkerLookupTable.propTypes = {
  blossomIDFromParent: string.isRequired,
  setText: func,
  workerLookup: func,
  classes: object,
  fetchingState: bool,
  responseData: arrayOf(
    shape({
      location_id: string,
      region: string,
      group: string,
      district: string,
      location_type: string,
      work_state: string,
      country_code: string,
    }),
  ),
  callbackFromParentSelections: func.isRequired,
  callbackFromParent: func.isRequired,
  callbackFromParentTotals: func.isRequired,
  callbackFromParentCountryCode: func.isRequired,
}
